// extracted by mini-css-extract-plugin
module.exports = {"sort-btn":"PlanTableHeader_sort-btn__1MCuC","sort-icon":"PlanTableHeader_sort-icon__1_BhY"};